import { asset } from '@/lib/asset';

export interface ShowcasePhoto {
  /** URL served from /public (already resolved against the Vite base). */
  src: string;
  /** Optional aspect-ratio hint for varied layout. */
  span?: 'tall' | 'wide' | 'square';
}

export const SHOWCASE_VIDEO = {
  src: asset('/media/intro.mp4'),
  poster: asset('/photos/XXXL.webp'),
};

export const SHOWCASE_PHOTOS: ShowcasePhoto[] = [
  { src: asset('/photos/XXXL.webp'), span: 'tall' },
  { src: asset('/photos/XXXL (1).webp'), span: 'square' },
  { src: asset('/photos/XXXL (2).webp'), span: 'wide' },
  { src: asset('/photos/XXXL (3).webp'), span: 'tall' },
  { src: asset('/photos/XXXL (4).webp'), span: 'square' },
  { src: asset('/photos/XXXL (5).webp'), span: 'square' },
  { src: asset('/photos/XXXL copy.webp'), span: 'wide' },
];
